<template>
  <div>
    <init-comp />
  </div>
</template>

<script>
import initComp from './init/index.vue'
export default {
  components: {
    initComp
  }
}
</script>
<style scoped></style>
